import React from 'react';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { useNavigate } from 'react-router-dom';
import { getCookie } from 'src/utils/cookies';
import Profile from '../Profile';
import Notifications from '../Notifications';
import NavbarGrouping from './NavbarGrouping';
import { NavBarGroupType } from './types';
import SproutsNavIcon from 'src/assets/SproutsNav.svg';
import { ThemeToggle } from '../ThemeToggle';
import TrailUserCard from './TrailUserCard';
import { useSelector } from 'react-redux';
import { useFeatureFlags } from 'src/hooks/useFeatureFlags';

type Props = {
  navData: NavBarGroupType;
  shouldDisplayDivider: (group: any[]) => boolean;
  isVisible: boolean;
  onMouseLeave: () => void;
  triggerCollapse: () => void;
  closeProfilePopoverRef: React.MutableRefObject<(() => void) | null>;
  closeNotificationsPopoverRef: React.MutableRefObject<(() => void) | null>;
  setIsPopoverOpen: (isOpen: boolean) => void;
  trialPeriod: number;
  userTenantType: string;
};

export const ExpandedNavbar = ({
  navData,
  shouldDisplayDivider,
  isVisible,
  onMouseLeave,
  triggerCollapse,
  closeProfilePopoverRef,
  closeNotificationsPopoverRef,
  setIsPopoverOpen,
  trialPeriod,
  userTenantType,
}: Props) => {
  const navigate = useNavigate();
  const token = getCookie('user');
  const {showOldNotifications} = useSelector((state: any) => state.notificationsState);
  const featureFlags = useFeatureFlags();

  return (
    <div
      className={`navbar-v2-expanded ${isVisible ? 'navbar-v2-expanded-visible' : ''}`}
      onMouseLeave={onMouseLeave}
    >
      <Grid2 xs={1} height={'100%'} width={'100%'}>
        <div className="nav-bar-container">
          <div className="nav-bar-icons-container">
            <div
              className="navbar-v2-header-wrapper"
              onClick={() => navigate('/target-profiles/accounts')}
            >
              <div className="navbar-v2-header">
                <img
                  src={SproutsNavIcon}
                  alt="sprouts-nav-icon"
                  className="first-icon"
                  width="16"
                  height="21"
                />
                <p className={'navbar-v2-title'}>Sprouts.ai</p>
              </div>
            </div>
            <div className="navbar-v2-groups-container">
              {Object.keys(navData).map((groupKey: string) =>
                groupKey === 'Settings' ? (
                  <React.Fragment key={groupKey} />
                ) : (
                  <NavbarGrouping
                    key={groupKey}
                    group={{ [groupKey]: navData[groupKey] }}
                    expanded={true}
                    shouldDisplayDivider={shouldDisplayDivider(navData[groupKey])}
                  />
                ),
              )}
            </div>
          </div>
          <div className="navbar-v2-profile-wrapper profile-wrapper-expanded">
            <div className="navbar-v2-profile-nav-items">
              { (userTenantType === 'SELF_SIGN_IN' || trialPeriod > 0) && (
                <TrailUserCard
                  isExpanded={true}
                  description="Need more time ? Contact our team to upgrade your plan."
                  count={trialPeriod}
                  maxCount={7}
                  label="Days remaining"
                  className="trail-user-card-expanded"
                />
              )}
              {(showOldNotifications && featureFlags?.notifications === false) && (
                <Notifications
                  expanded={true}
                  triggerCollapseNav={triggerCollapse}
                  closePopoverRef={closeNotificationsPopoverRef}
                  setIsPopoverOpen={setIsPopoverOpen}
                />
              )}
              {/* <ThemeToggle expanded={true} /> */}
              <NavbarGrouping
                key={'Settings'}
                group={{ ['Settings']: navData['Settings'] }}
                expanded={true}
                shouldDisplayDivider={false}
                shouldShowGroupName={false}
              />
            </div>
            {token ? (
              <Profile
                expanded={true}
                triggerCollapseNav={triggerCollapse}
                closePopoverRef={closeProfilePopoverRef}
                setIsPopoverOpen={setIsPopoverOpen}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
      </Grid2>
    </div>
  );
};
